import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { PlatformService } from '../service/platform.service';

export const redirectGuard: CanActivateFn = (route, state) => {
  const platform= inject (PlatformService);
  const router = inject(Router);
  const path = state.url;

  if (decodeURIComponent(path.split('?')[0]).replace(/\/$/, '') === '/دانلود-اپلیکیشن') {
    return router.parseUrl('/download/');
  }

  if (path === '/about-us/' || path === '/AboutUs/' || path === '/about/') {
    router.navigate(['/aboutus']);
    return false;
  } else if (path === '/privacy-policy/' || path === '/Rules/'  || path === '/privacy/') {
    router.navigate(['/rules']);
    return false;
  } else if (
    path === '/services/' || 
    decodeURIComponent(path) === '/tag/خرید-طلا/' || 
    decodeURIComponent(path) === '/tag/آب-شده/' || 
    decodeURIComponent(path) === '/category/شمش-طلا/' 
  ) {
    router.navigate(['/']);
    return false;
  // مسیر فروشگاه فعلاً کامنت شده است؛ تا وقتی برنگردد این ریدایرکت هم
  // باید غیرفعال بماند، وگرنه /store/ به مسیری می‌رود که وجود ندارد و
  // دوباره به همین گارد برمی‌گردد و حلقه بی‌نهایت می‌سازد
  // } else if (
  //   path === '/shop/' ||
  //   path === '/store/' ||
  //   path === '/market/' ||
  //   path === '/bazaar/' ||
  //   decodeURIComponent(path) === '/فروشگاه/' ||
  //   decodeURIComponent(path) === '/خرید/' ||
  //   decodeURIComponent(path) === '/خرید-طلا/' ||
  //   decodeURIComponent(path) === '/پلاک-طلا/' ||
  //   decodeURIComponent(path) === '/خرید-پلاک-طلا/' ||
  //   decodeURIComponent(path) === '/خرید-طلا-آنلاین/' ||
  //   decodeURIComponent(path) === '/فروش-طلا/'
  // ) {
  //   router.navigate(['/store']);
  //   return false;
  } else if (path === '/contact-us/') {
    router.navigate(['/contactus']);
    return false;
  } else if (path === '/Trust/' || decodeURIComponent(path) === '/چطور-به-بازر-اعتماد-کنیم-؟/') {
    router.navigate(['/trust']);
    return false;
  } else if (decodeURIComponent(path) === '/پیش-بینی-قیمت-طلا/بلاگ-بازر/') {
    if (platform.isBrowser()) {
      window.open('https://baazar.ir/mag/', '_blank');
      router.navigate(['/']);
    }
    return false;
  }

  return true;
};
